import TrendCharts from "./TrendCharts";

export default TrendCharts;
